import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSamples = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M2.859 13.765a.3.3 0 0 1 0-.53l3.069-1.643a1 1 0 0 1 .944 0l3.07 1.644a.3.3 0 0 1 0 .529l-3.07 1.644a1 1 0 0 1-.944 0l-3.07-1.644Zm15.213 1.644a1 1 0 0 1-.944 0l-3.07-1.644a.3.3 0 0 1 0-.53l3.07-1.643a1 1 0 0 1 .944 0l3.07 1.644a.3.3 0 0 1 0 .529l-3.07 1.644Zm-5.6-9a1 1 0 0 1-.944 0l-3.07-1.644a.3.3 0 0 1 0-.53l3.07-1.643a1 1 0 0 1 .944 0l3.07 1.644a.3.3 0 0 1 0 .529l-3.07 1.644Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16.9 20.786a.3.3 0 0 1-.442.264l-3.23-1.73a1 1 0 0 1-.528-.882v-3.223a.3.3 0 0 1 .442-.264l3.23 1.73a1 1 0 0 1 .528.882v3.223ZM10.772 7.681a1 1 0 0 1 .528.882v3.223a.3.3 0 0 1-.442.264l-3.23-1.73a1 1 0 0 1-.528-.882V6.215a.3.3 0 0 1 .442-.265l3.23 1.731Zm-5.6 9a1 1 0 0 1 .528.882v3.223a.3.3 0 0 1-.442.264l-3.23-1.73a1 1 0 0 1-.528-.882v-3.223a.3.3 0 0 1 .442-.264l3.23 1.73Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M7.1 17.563a1 1 0 0 1 .527-.882l3.23-1.73a.3.3 0 0 1 .443.264v3.223a1 1 0 0 1-.528.882l-3.23 1.73a.3.3 0 0 1-.442-.264v-3.223ZM16.458 5.95a.3.3 0 0 1 .442.265v3.223a1 1 0 0 1-.528.882l-3.23 1.73a.3.3 0 0 1-.442-.264V8.563a1 1 0 0 1 .527-.882l3.23-1.73ZM18.3 17.563a1 1 0 0 1 .527-.882l3.23-1.73a.3.3 0 0 1 .443.264v3.223a1 1 0 0 1-.528.882l-3.23 1.73a.3.3 0 0 1-.442-.264v-3.223Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcSamples");

export { IcSamples };
//# sourceMappingURL=ic-samples.js.map
